import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AccountSelectionListComponent } from "../../components/account-selection-list/account-selection-list.component";
import { PAGE_ROUTES } from "../../constants";
import { NgIf } from "@angular/common";
import { AccountOption } from "../../services/auth.service";

@Component({
  selector: "app-account-selection",
  standalone: true,
  imports: [NgIf, AccountSelectionListComponent],
  templateUrl: "./account-selection.component.html",
  styleUrl: "./account-selection.component.scss"
})
export class AccountSelectionComponent implements OnInit {
  protected accounts: AccountOption[] = [];
  protected accessToken = '';
  protected sessionId = '';
  protected loginHint = '';

  constructor(
    private _route: ActivatedRoute,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this._route.queryParamMap.subscribe((params) => {
      const accountsJson = params.get("accounts");
      const accessToken = params.get("accessToken");
      const sessionId = params.get("sessionId");
      const loginHint = params.get("loginHint");

      if (accessToken && accountsJson) {
        this.accessToken = accessToken;
        this.sessionId = sessionId || '';
        this.loginHint = loginHint || '';
        this.accounts = accountsJson ? JSON.parse(accountsJson) : [];
      } else {
        this._router.navigate([PAGE_ROUTES.HOME]);
      }
    });
  }
}
